import React, { useMemo } from 'react';

function Step1Basics({ formData, onChange, onNext }) {
  // Generate URL slug from name and gender
  const autoSlug = useMemo(() => {
    if (!formData.name) return '';
    const clean = formData.name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return `${formData.gender}-${clean}`;
  }, [formData.name, formData.gender]);

  const canProceed = formData.name.trim().length > 0;

  return (
    <div className="outfit-card">
      <div className="outfit-card-header">
        <h2 className="outfit-card-title">Step 1: Trend Basics & Target Audience</h2>
      </div>

      <div className="wizard-form-group">
        <label htmlFor="trend-name">Trend Name *</label>
        <input
          id="trend-name"
          type="text"
          className="wizard-input"
          placeholder="e.g. Baggy Streetwear 2026, Minimal Linen Summer..."
          value={formData.name}
          onChange={(e) => onChange('name', e.target.value)}
          autoFocus
        />
      </div>

      <div className="wizard-form-group">
        <label>Gender *</label>
        <div className="kb-gender-pills" style={{ width: 'fit-content' }}>
          <button
            type="button"
            className={`kb-gender-pill ${formData.gender === 'men' ? 'active' : ''}`}
            onClick={() => onChange('gender', 'men')}
          >
            Men
          </button>
          <button
            type="button"
            className={`kb-gender-pill ${formData.gender === 'women' ? 'active' : ''}`}
            onClick={() => onChange('gender', 'women')}
          >
            Women
          </button>
        </div>
      </div>

      <div className="wizard-form-group">
        <label htmlFor="trend-image">Cover Image URL (Optional)</label>
        <input
          id="trend-image"
          type="url"
          className="wizard-input"
          placeholder="https://cdn.polopan.com/trends/cover.jpg"
          value={formData.image || ''}
          onChange={(e) => onChange('image', e.target.value)}
        />
        {formData.image && (
          <div className="wizard-preview-box">
            <img
              src={formData.image}
              alt="Cover Preview"
              className="wizard-img-thumb"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span style={{ fontSize: '12px', color: '#64748b' }}>Cover Image Preview</span>
          </div>
        )}
      </div>

      {autoSlug && (
        <div className="wizard-form-group">
          <label>Generated Trend Handle / URL Slug</label>
          <div className="wizard-slug-preview">{autoSlug}</div>
        </div>
      )}

      <div className="wizard-nav-bar">
        <div />
        <button
          type="button"
          className="outfit-btn outfit-btn-primary"
          disabled={!canProceed}
          onClick={onNext}
        >
          Next: Select CCI Formula &rarr;
        </button>
      </div>
    </div>
  );
}

export default Step1Basics;
